"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = exports.SLS_HOST = exports.slsConfig = exports.logStore = void 0;
exports.logStore = 'ewt-web-log';
exports.slsConfig = {
    // 测试环境，只有本地和测试环境走这里
    test: {
        logProject: "sls-ewt-test-tech-infra-fe",
        logStore: exports.logStore,
    },
    // 生产环境，除了本地和测试，都走这里，防止环境的判断有问题丢日志
    production: {
        logProject: "sls-ewt-tech-infra-fe",
        logStore: exports.logStore,
    },
};
exports.SLS_HOST = "cn-hangzhou.log.aliyuncs.com";
exports.version = '2.0.0';
